import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Amenities from "@/components/site/Amenities";
import Stay from "@/components/site/Stay";
import TequilaTastings from "@/components/site/TequilaTastings";
import Testimonials from "@/components/site/Testimonials";
import Booking from "@/components/site/Booking";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Chatbot from "@/components/site/Chatbot";

export default function LandingPage() {
    return (
        <main className="overflow-x-hidden" data-testid="landing-page">
            <Navbar />
            <Hero />
            <About />
            <Services />
            <Gallery />
            <Amenities />
            <Stay />
            <TequilaTastings />
            <Testimonials />
            <Booking />
            <FAQ />
            <Contact />
            <Footer />
            <Chatbot />
        </main>
    );
}
